import React, { useState, StyleSheet } from "react";
// reactstrap components
import {
    Card,
    CardBody,
    CardTitle,
    CardText,
    FormGroup,
    Label,
    Button,
    Input,
    Container,
    Row,
    Col,
    Modal,
    ModalBody,
    Form,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Collapse
} from "reactstrap";
import Datetime from 'react-datetime';
// core components
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
import { handleResponse, authHeader } from '_helpers';
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader2.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";

import { useDropzone } from 'react-dropzone'
import 'assets/css/react-datetime.css'
import 'assets/css/wizard.css'

const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16
};

const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: 'border-box'
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
};

const img = {
    display: 'block',
    width: 'auto',
    height: '100%'
};

//function TelePage2() {
const BookingPage = (props) => {
    var moment = require('moment');
    require('moment/locale/th');

    const [dateFocus, setDateFocus] = useState(false);
    const [errMsg, setErrMsg] = useState(false);
    const [modalError, setModalError] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [modalNote, setModalNote] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");
    const ClinicText = ["", "ในเวลาราชการ", "SMC Clinic", "คลินิกสูงวัยใส่ใจผิวพรรณ"];

    const [modalHoliday, setModalHoliday] = useState(false);
    const [holidayText, setHolidayText] = useState('');
    const [currentDate, setcurrentDate] = useState(moment());
    const [holidays, setHolidays] = useState([]);
    const [disableddays, setDisableddays] = useState([]);

    const liff = window.liff;
    liff.init({
        liffId: '1654063801-bZdLjP3w'
    })
        .then(() => {

            if (liff.isLoggedIn()) {

                liff.getProfile().then(function (profile) {

                    authenticationService.login(profile.userId, profile.userId)
                        .then(
                            user => {
                                //const { from } = this.props.location.state || { from: { pathname: "/home" } };
                                //this.props.history.push(from);
                                //window.alert(user)
                            },
                            error => {
                                console.log(error);
                            }
                        );

                }).catch(function (error) {
                    window.alert('Error getting profile: ' + error);
                });

            }
        })
        .catch((err) => {

        });

    React.useEffect(() => {
        /*
                    fetch('/api/v1/profile/address', {
                        method: 'GET',
                        headers: authHeader()
                    })
                    .then(handleResponse)
                    //.then(response => response.json())
                    .then(
                        (result) => {
                            console.log(result)
                            setPhone(result.phone)
                            setAddress(result.fullAddress)
                            setFullName(result.fullName)
                        },
                        (error) => {
                            alert(error);
                        }
                    );
        
        */
        

        document.body.classList.add("landing-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");

        //setModalNote(true);

        return function cleanup() {
            document.body.classList.remove("landing-page");
            document.body.classList.remove("sidebar-collapse");
        };
    }, []);


    const [ServiceType, setType] = useState(1); //default นัดหมาย
    const [THDate, setTHDate] = useState("");
    const [AppointDatetime, setAppointDatetime] = useState("");
    const [AppointDate, setAppointDate] = useState("");
    const [AppointTime, setAppointTime] = useState("");
    const [SlotType, setSlotType] = useState(0);
    const [renderButton, setRenderButton] = useState([]);
    const [Description, setDescription] = useState("");
    const [FullName, setFullName] = React.useState("");
    const [Id, setId] = useState("");
    const [FileData, setFileData] = useState("");
    const [files, setFiles] = useState([]);
    const [theArray, setTheArray] = useState([]);

    const [displayNoTime, setDisplayNoTime] = useState(false);
    const [level, setLevel] = useState(1);
    const [progressLevel, setProgressLevel] = useState("16.66%");

    var fileTxt = "";

    const buttonContent = renderButton.map((post, index) =>
        <Button key={index} color={(post.slotTime == AppointTime ? "success" : "info")} size="sm" style={{width:'75px'}} onClick={e => handleTimeSelect(post.slotTime)}> {post.slotTime.substring(0, 5)}</Button >
    );


    const handleTimeSlot = (date) => {
        setAppointDate(date);
        fetch('/api/v1/timeslot?AppointDatetime=' + date + '&SlotType=' + SlotType, {
            method: 'GET',
            headers: authHeader()
        })
            .then(handleResponse)
            //.then(response => response.json())
            .then(
                (result) => {
                    setRenderButton(result.data);
                    setDisplayNoTime(result.data != null && result.data.length == 0); 
                },
                (error) => {
                    alert(error);
                }
            );
    }


    const handleTimeSelect = (time) => {
        setAppointTime(time);
        setAppointDatetime(AppointDate + ' ' + time)
    }

    const handleClear = (evt) => {
        evt.preventDefault();
        setFiles([]);
    }
    const { getRootProps, getInputProps } = useDropzone({
        accept: 'image/*',
        onDrop: acceptedFiles => {
            acceptedFiles.map(file =>
                setFiles(f => [...f, Object.assign(file, { preview: URL.createObjectURL(file) })])
            )
            /*
            setFiles(
                
                acceptedFiles.map(file =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file)
                    })
                )

            );
            */
        },

    });



    const handleLevel = (level) => {

        if (level == 1) {
            setLevel(level);
            setProgressLevel("16.66%")
        }
        else if (level == 2) {
            setLevel(level);
            setProgressLevel("49.99333333333334%") 
        }
        else if (level == 3) {
            //evt.preventDefault();
            var cntErr = 0;
            var errMsg = ''


            if (ServiceType == 2) {
                if (AppointTime == null || AppointTime == '') {
                    cntErr += 1;
                    errMsg = 'กรุณาระบุเวลารับบริการ';
                }
                if (!moment(AppointDate).isValid()) {
                    cntErr += 1;
                    errMsg = 'กรุณาระบุวันที่ต้องการรับบริการ';
                }
                if (SlotType == null || SlotType == '') {
                    cntErr += 1;
                    errMsg = 'กรุณาระบุช่วงเวลารับบริการ';
                }
            }
            else {
                if (!moment(AppointDate).isValid()) {
                    cntErr += 1;
                    errMsg = 'กรุณาระบุวันที่ต้องการรับบริการ';
                }
            }

  

            if (cntErr > 0) {
                setErrMsg(errMsg);
                setModalError(true);
            }
            else {
                setLevel(level);
                setProgressLevel("83.3266666666666%")
            }        
        }
    }

    async function uploadWithJSON(file) {
        const toBase64 = file => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
        //console.log(file)

        const data = {
            fileName: file.name,
            fileSize: file.size,
            fileType: file.type,
            fileBase64: await toBase64(file),
        }

        return await data;
    }

    const thumbs = files.map(file => (
        <div style={thumb} key={file.name}>
            <div style={thumbInner}>
                <img
                    src={file.preview}
                    style={img}
                />
            </div>
        </div>
    ));

    const handleType = (serviceType) => {
        setType(serviceType);
        //setAppointDate('');
        handleLevel(2);
    }

    const handleSlot = (slotType) => {
        setSlotType(slotType)
        fetchHoliday(moment().format('YYYY/M'), slotType);
        
        setAppointDate(null);  
        setRenderButton([]);
        handleLevel(2);
    }

    const handleSubmit = (evt) => {
        evt.preventDefault();

        var cntErr = 0;
        var errMsg = '';


        if (Description == null || Description == '') {
            cntErr += 1;
            errMsg = 'กรุณาระบุความต้องการ หรือ อาการเบื้องต้น';
        }

        if (ServiceType == 2) {
            if (AppointTime == null || AppointTime == '') {
                cntErr += 1;
                errMsg = 'กรุณาระบุเวลารับบริการ';
            }
            if (!moment(AppointDate).isValid()) {
                cntErr += 1;
                errMsg = 'กรุณาระบุวันที่ต้องการรับบริการ';
            }

            if (SlotType == null || SlotType == '') {
                cntErr += 1;
                errMsg = 'กรุณาระบุช่วงเวลารับบริการ';
            }
         
        }
       
        if (cntErr > 0) {
            setErrMsg(errMsg);
            setModalError(true);
        }
        else {

            var dd = moment.locale('th')
            setTHDate(moment(AppointDatetime).add(543, 'year').format('Do MMMM YYYY'));
            setModal2(true);
        }     
    }

    const handleConfirm = (evt) => {
        evt.preventDefault();
        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");
        //alert(currentUser.fullName);

        //alert(`Submitting Type ${ServiceType} Date ${AppointDatetime} LineID ${LineID}, Phone ${Phone}, ShippingAddress ${ShippingAddress}, Description ${Description} `)

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json-patch+json',
                'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
            },
            body: JSON.stringify({
                "serviceType": ServiceType,
                "slotType": SlotType,
                "appointDatetime": AppointDatetime,
                "appointDate": AppointDate,
                "appointTime": AppointTime,
                "description": Description,
            })
        };

        fetch('/api/v1/bookings', requestOptions)
            .then(handleResponse)
            .then(
                (result) => {
                    //console.log(result);

                    //console.log(files);
                    var totalFile = files.length;
                    if (totalFile > 0) {
                        files.map((file, index) => {
                            const prom = uploadWithJSON(file);
                            Promise.resolve(prom).then((e) => {
                                //console.log(e);
                                const reqOpt = {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json-patch+json',
                                        'Authorization': 'Bearer ' + authenticationService.currentUserValue.token,
                                    },
                                    body: JSON.stringify({
                                        "bookingID": result.data.bookingID,
                                        "fileName": e.fileName,
                                        "fileCategoryID": 0,
                                        "fileType": e.fileType,
                                        "fileSize": e.fileSize,
                                        "fileBase64": e.fileBase64,
                                    })
                                };

                                fetch('/api/v1/bookings/upload', reqOpt)
                                    .then(handleResponse)
                                    .then(
                                        (resultUpload) => {
                                            //console.log(result);
                                            //alert(result.data.fileID)
                                            if (index == (totalFile - 1)) {
                                                if (liff.isInClient()) {
                                                    const encoded = encodeURI('https://q.trangskin.go.th/bookticket.php?number=' + result.data.bookingNumber + '&name=' + currentUser.fullName + '&date=' + THDate + '&time=' + AppointTime.substring(0, 5));

                                                    liff.sendMessages([{
                                                        'type': 'text',
                                                        'text': `#ยืนยันการนัดหมาย ${ClinicText[SlotType]} - ${currentUser.fullName} วันที่ ${THDate} เวลา ${AppointTime.substring(0,5)} น. ` 
                                                    }]).then(function () {

                                                        liff.sendMessages([{
                                                            'type': 'image',
                                                            'originalContentUrl': encoded,
                                                            'previewImageUrl': encoded,
                                                            'animated': false
                                                        }]).then(function () {
                                                            liff.closeWindow();
                                                        }).catch(function (error) {
                                                            window.alert('Error sending message: ' + error);
                                                        });


                                                    }).catch(function (error) {
                                                        window.alert('Error sending message: ' + error);
                                                    });


                                                } else {
                                                    const { from } = props.location.state || { from: { pathname: "/home" } };
                                                    props.history.push(from);
                                                }
                                            }
                                        },
                                        (error) => {
                                            console.log(error);
                                            alert(error)
                                        }
                                    )
                            });
                        });
                    }
                    else
                    {
                            if (liff.isInClient()) {
                                const encoded = encodeURI('https://q.trangskin.go.th/bookticket.php?number=' + result.data.bookingNumber + '&name=' + currentUser.fullName + '&date=' + THDate + '&time=' + AppointTime.substring(0, 5));
                                liff.sendMessages([{
                                    'type': 'text',
                                    'text': `#ยืนยันการนัดหมาย ${ClinicText[SlotType]} - ${currentUser.fullName} วันที่ ${THDate} เวลา ${AppointTime.substring(0, 5)} น.` 
                                }]).then(function () {
                                    
                                    liff.sendMessages([{
                                        'type': 'image',
                                        'originalContentUrl': encoded,
                                        'previewImageUrl': encoded,
                                        'animated': false
                                    }]).then(function () {
                                        liff.closeWindow();
                                    }).catch(function (error) {
                                        window.alert('Error sending message: ' + error);
                                    });


                                }).catch(function (error) {
                                    window.alert('Error sending message: ' + error);
                                });


                            } else {
                                const { from } = props.location.state || { from: { pathname: "/home" } };
                                props.history.push(from);
                            }
                    }
                    //setId(result.data.teleID);
                    //setModal2(true);

                    //bug อยู่  ต้องรอให้ upload เสร็จก่อน ถึงจะปิดจอ
                    /*
                    if (liff.isInClient()) {

                        liff.sendMessages([{
                            'type': 'text',
                            'text': '#ยืนยันการจอง'
                        }]).then(function () {
                            //window.alert('Message sent');
                        }).catch(function (error) {
                            window.alert('Error sending message: ' + error);
                        });

                        //liff.closeWindow();
                    } else {
                        const { from } = props.location.state || { from: { pathname: "/home" } };
                        props.history.push(from);
                    }
                    */
                },
                (error) => {
                    setIcon("far fa-question-circle");
                    setErrMsg(error);
                    setModal2(false);
                    setModalError(true);
                }
        )
    }

    const currentUser = authenticationService.currentUserValue;


    //check login
    if (!currentUser) {
        // not logged in so redirect to login page with the return url
        return <Redirect to={{ pathname: '/login', /*state: { from: props.location }*/ }} />
    }

    const onSubmit = values => {
        console.log(JSON.stringify(values));
    };



    const fetchHoliday = (yearMonth, slotType) => {
        fetch('/api/holiday/' + yearMonth, {
            method: 'GET',
            headers: authHeader()
        })
            .then(handleResponse)
            //.then(response => response.json())
            .then(
                (result) => {
                    setHolidays(result.data)

                    var url = "";
                    if (slotType == 1)
                        url = '/api/v1/disabled/booking/' + yearMonth;
                    else if (slotType == 2)
                        url = '/api/v1/disabled/smc/' + yearMonth;

                    fetch(url, {
                        method: 'GET',
                        headers: authHeader()
                    })
                    .then(handleResponse)
                    //.then(response => response.json())
                    .then(
                        (result) => {
                            setDisableddays(result.data)

                        },
                        (error) => {
                            alert(error);
                        }
                    );
                },
                (error) => {
                    alert(error);
                }
            );
    };

    const handleCurrentDate = (dayAmt, unit) => {
        var curr = moment(currentDate).add(dayAmt, unit)
        setcurrentDate(curr);
        fetchHoliday(curr.format('YYYY/M'), SlotType);
        return false;
    }

    const handleNavigate = (nextView, currentView, currDate) => {
        if (nextView == 'days') {
            setcurrentDate(currDate);
            fetchHoliday(currDate.format('YYYY/M'), SlotType);
        }
        return nextView;
    }

    const handleHoliday = (e, txt) => {
        e.preventDefault();
        setHolidayText(txt);
        setModalHoliday(true);
    }

    function isDateValid(e, selectedDate) {
        var holiday = holidays.find(h => moment(h.holidayDate).format("YYYYMMDD") === moment(e).format("YYYYMMDD"))
        var disabledday = disableddays.find(h => moment(h.disabledDatetime).format("YYYYMMDD") === moment(e).format("YYYYMMDD"))

        if (holiday != null)
            return false
        else if (disabledday != null)
            return false
        else
            return (SlotType > 1) ?
                //(e.day() == 1 && e > new Date(2021, 0, 21, 0, 0, 0, 0))
                ((e.day() == 1 || e.day() == 4 || e.day() == 6) && e > (new Date()).setDate((new Date().getDate())))
                :
                (e.day() !== 0 && e.day() !== 6 && e > (new Date()).setDate((new Date().getDate())))

        //(e.day() !== 0 && e.day() !== 6 && e > (new Date()).setDate((new Date().getDate() - 1)))
    }

    function renderDay(props, currentDate, selectedDate) {
        var holiday = holidays.find(h => moment(h.holidayDate).format("YYYYMMDD") === moment(currentDate).format("YYYYMMDD"))
        var disabledday = disableddays.find(h => moment(h.disabledDatetime).format("YYYYMMDD") === moment(currentDate).format("YYYYMMDD"))

        var hdt = (holiday != null) ? holiday.name : ((disabledday != null) ? disabledday.name : '');

        // Adds 0 to the days in the days view
        if ((props.className.indexOf('rdtDisabled') >= 0) &&
            (
                (SlotType != 1) ?
                ((currentDate.day() == 1 || currentDate.day() == 4 || currentDate.day() == 6) && currentDate > (new Date()).setDate((new Date().getDate())))
                :
                (currentDate.day() !== 0 && currentDate.day() !== 6 && currentDate > (new Date()).setDate((new Date().getDate()))))
                
        )
        {
            props.className += ' text-danger';
            //return <td {...props} style={{ textDecoration: 'Line-Through' }}>{currentDate.date()}</td>;
            return <td>
                
                <button
                    onClick={e => handleHoliday(e, hdt)}
                    class="btn btn-danger btn-icon btn-round" style={{ background: 'red' }}
                >
                    <span className="text-white" style={{ textDecoration: 'Line-Through' }}>{currentDate.date()}</span>
                </button>
            </td>;

            //<td {...props}>{currentDate.date()}</td>;
        }
        else {
            return <td {...props}>{currentDate.date()}</td>;
        }
    }

  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <IndexHeader  />
        <div className="main">
                  <div className="section" style={{ padding: '70px 0 0' }}>
                      <Container>
                          <Row>
                              <Col md="2">
                              </Col>
                              <Col md="8">
                                  <div className="hero-images-container " style={{ marginTop: '-20vh', maxWidth:'680px'}}>
                                      <img
                                          alt="..."
                                          src={require("assets/img/newskinlogo.png")}
                                      ></img>
                                  </div>
                              </Col>
                              <Col md="2">
                              </Col>
                          </Row>
                      </Container>
                  </div>  
        </div>
        
             <div className="section section-contact-us" style={{padding:0}}>
                  <Container>
                    <form role="form" action="" method="post" className="f1 text-center">
                      <div className="f1-steps">
                          <div className="f1-progress">
                                  <div className="f1-progress-line" style={{ width: progressLevel }}></div>
                                  {/*16.66  49.99333333333334 83.3266666666666   */}
                          </div>
                              
                          <div style={{cursor:'pointer'}} onClick={e => handleLevel(1)} className={(level >= 1) ? "f1-step active" : "f1-step"}>
                            <div className="f1-step-icon"><i className="fa fa-user"></i></div>
                            <p>ประเภท</p>
                          </div>
                          <div style={{ cursor: 'pointer' }} onClick={e => handleLevel(2)} className={(level >= 2) ? "f1-step active" : "f1-step"}>
                            <div className="f1-step-icon"><i className="fa fa-key"></i></div>
                            <p>เลือกวันเวลา</p>
                          </div>
                          <div style={{ cursor: 'pointer' }} onClick={e => handleLevel(3)} className={(level >= 3) ? "f1-step active" : "f1-step"}>
                                  <div href="#" className="f1-step-icon"><i className="fa fa-save"></i></div>
                            <p>ข้อมูลเบื้องต้น</p>
                          </div>
                      </div>

                      <Collapse isOpen={(level==1)}>
                          <Row style={{ marginBottom: "1em" }} >
                              <Col className="text-center ml-auto mr-auto" xs="12">

                                <Card hidden body inverse style={{ background: "#1e71a1", width: "100%" }}>
                                    <CardBody style={{ padding: "0 1rem" }}>
                                        <CardTitle tag="h4" style={{ marginTop: 0}}>นัดล่วงหน้า</CardTitle>
                                        <CardText className="text-left">
                                              นัดหมายล่วงหน้า 1 วัน <br />
                                              เรียกคิวตามเวลานัดหมาย<br />
                                              ยืนยันตัวก่อนเวลานัดหมาย 15 นาที<br /> &nbsp;
                                        </CardText>
                                        <Button
                                              color="info"
                                              onClick={e => handleType(1)}
                                        >
                                              นัดหมาย
                                        </Button>
                                    </CardBody>
                                </Card>

                                <Card hidden body inverse style={{ background:"#1ea160", width: "100%" }}>
                                    <CardBody style={{ padding: "0 1rem"}}>
                                        <CardTitle tag="h4" style={{ marginTop: 0 }}>จองคิววันนี้</CardTitle>
                                        <CardText className="text-left">
                                              เปิดจองคิวทั่วไปเฉพาะวันนี้เท่านั้น<br/>
                                              หากเลยคิวของท่านสามารถแจ้งได้ที่เวชระเบียน
                                        </CardText>
                                        <Button
                                              color="success"

                                              onClick={e => handleType(2)}
                                        >
                                              จองเลย
                                        </Button>
                                  </CardBody>
                                </Card>

                                <Card body inverse style={{ background:"#1ea160", width: "100%" }} onClick={e => handleSlot(1)}>
                                    <CardBody style={{ padding: "0 1rem"}}>
                                        <CardTitle tag="h4" style={{ marginTop: 0 }}>เวลาทั่วไป</CardTitle>
                                        <CardText className="text-left">
                                              เวลาราชการ จันทร์-ศุกร์<br/>
                                              (8.30 - 16.30 น.)
                                        </CardText>
                                        <Button
                                              block
                                              color="success"
                                              size="lg"
                                              style={{ fontSize: '1.2em' }}
                                              onClick={e => handleSlot(1)}
                                        >
                                              เลือกเวลาทั่วไป
                                        </Button>
                                  </CardBody>
                                </Card>

                                <Card body inverse style={{ background: "#1e71a1", width: "100%" }} onClick={e => handleSlot(2)}>
                                    <CardBody style={{ padding: "0 1rem" }}>
                                        <CardTitle tag="h4" style={{ marginTop: 0}}>คลินิกพิเศษเฉพาะทาง (SMC)</CardTitle>
                                              <CardText className="text-left">
                                                  นอกเวลาราชการ วันจันทร์ พฤหัสฯ <br />
                                                  (16.30 - 20.00 น.)<br />
                                                  และวันเสาร์ <br />
                                                  (08.00 - 12.00 น.)<br />
                                        </CardText>
                                        <Button
                                              block       
                                              color="info"
                                              size="lg"
                                              style={{ fontSize: '1.2em' }}
                                              onClick={e => handleSlot(2)}
                                        >
                                              เลือกคลินิกพิเศษ
                                        </Button>
                                    </CardBody>
                                </Card>
                                      {/*}
                                      <Card body inverse style={{ background: "#C73C00", width: "100%" }} onClick={e => handleSlot(3)}>
                                          <CardBody style={{ padding: "0 1rem" }}>
                                              <CardTitle tag="h4" style={{ marginTop: 0 }}>คลินิกสูงวัยใส่ใจผิวพรรณ</CardTitle>
                                              <CardText className="text-left">
                                                  นอกเวลาราชการ วันจันทร์<br />
                                                  (16.30 - 20.00 น.)<br />
                                              </CardText>
                                              <Button
                                                  block
                                                  color="primary"
                                                  size="lg"
                                                  style={{ fontSize: '1.2em' }}
                                                  onClick={e => handleSlot(3)}
                                              >
                                                  เลือกคลินิกพิเศษ
                                        </Button>
                                          </CardBody>
                                      </Card>
                                      */}
                              </Col>
                          </Row>
                      </Collapse>

                          <Collapse isOpen={(level == 2)}>
                              <Row hidden style={{ marginBottom: "1em" }} >
                                  <Col className="text-left ml-auto mr-auto" lg="6" md="8" xs="12">
                                      <FormGroup check className="form-check-radio" inline

                                      >
                                          <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                              <Input
                                                  defaultValue="option1"
                                                  id="inlineRadio1"
                                                  name="ServiceType"
                                                  type="radio"
                                                  onChange={e => handleSlot(1)/*setType(1)*/}
                                              ></Input>  เวลาราชการ (วันจันทร์ - ศุกร์ 8.30 - 16.30 น.) <span className="form-check-sign"></span>
                                          </Label>
                                      </FormGroup>
                                  </Col>

                                  <Col className="text-left ml-auto mr-auto" lg="6" md="8" xs="12">

                                      <FormGroup check className="form-check-radio" inline>
                                          <Label check style={{ paddingLeft: '10px', fontSize: 18 }}>
                                              <Input
                                                  defaultValue="option2"
                                                  id="inlineRadio2"
                                                  name="ServiceType"
                                                  type="radio"
                                                  onChange={e => handleSlot(2)/*setType(2)*/}
                                              ></Input>  คลินิกพิเศษเฉพาะทาง (SMC วันจันทร์ 18.00 - 20.00 น.) <span className="form-check-sign"></span>
                                          </Label>
                                      </FormGroup>
                                  </Col>
                              </Row>
                        <Row>
                          <Col className="ml-auto mr-auto" lg="6" md="8">
                              <FormGroup
                                  style={{ padding: '0 0px',zIndex:1 }}
                                  className={
                                      "input-lg" + (dateFocus ? " input-group-focus" : "")
                                  }
                              >
                                  <i className="far fa-calendar-check fa-2x" style={{
                                      position: 'absolute',
                                      left: '12px',
                                      top: '15px',
                                      zIndex: 1,

                                  }}
                                          ></i>
                                  <Modal
                                          className="modal-dialog modal-dialog-centered"
                                          toggle={() => setModalHoliday(false)}
                                          isOpen={modalHoliday}>

                                          <div className="modal-header" style={{ color: 'white', background: '#b92a34', paddingBottom: '10px' }}>
                                              <h5 className="modal-title" id="exampleModalLiveLabel">
                                                  แจ้งเตือนวันหยุด
                                              </h5>
                                              <button
                                                  aria-label="Close"
                                                  className="close"
                                                  type="button"
                                                  onClick={() => setModalHoliday(false)}
                                              >
                                                  <span aria-hidden={true} style={{ color: 'white' }}>×</span>
                                              </button>
                                          </div>
                                          <div className="modal-body">
                                              <p>{holidayText}</p>
                                          </div>

                                      </Modal>
                                  <Datetime

                                              renderYear={function (props, year, selectedDate) { return <td {...props}>{year + 543}</td>; }}
                                              isValidDate={isDateValid}
                                              /*
                                              isValidDate={e =>
                                                  (SlotType > 1) ?
                                                      (
                                                          (e.day() == 1 && e > new Date(2021,0,21,0,0,0,0))
                                                          || (e.format('YYYY-MM-DD') == '2021-01-21')
                                                      )
                                                      :
                                                      (e.day() !== 0 && e.day() !== 6 && e > (new Date()).setDate((new Date().getDate())))
                                              }
                                            */
                                              renderDay={renderDay}
                                              onBeforeNavigate={(a, b, c) => handleNavigate(a, b, c)}
                                              onNavigateForward={(dayAmt, unit) => handleCurrentDate(dayAmt, unit)}
                                              onNavigateBack={(dayAmt, unit) => handleCurrentDate((-1 * dayAmt), unit)}
                                              inputProps={{
                                                  name: "AppointDate", placeholder: "วันที่รับบริการ", readOnly: 'readonly'
                                                  , style: {
                                                      fontSize: '1.2em', borderRadius: 0, paddingLeft: '50px', cursor: 'pointer', background: '#ffffff', color: '#000000'
                                                  }
                                              }}
                                              renderInput={(props) => {
                                                  return <input {...props} value={(AppointDate != null) ? props.value : ''} />
                                              }}
                                              closeOnSelect={true}
                                              closeOnTab={true}
                                              dateFormat="D MMMM BBBB" timeFormat={false}
                                              onFocus={() => setDateFocus(true)}
                                              onBlur={() => setDateFocus(false)}
                                              onChange={e => handleTimeSlot(e.format('YYYY-MM-DD'))}
                                  />
                                      </FormGroup>
                                      
                          </Col>
                          </Row>
                       
                              <Row style={{ margin: "0 -30px 0 -30px" }}>
                                  <Col className="text-center ml-auto mr-auto" xs="12">
                                      <Card body style={{padding: 0}} /*inverse style={{ background: "#1e71a1", width: "21rem" }}*/>
                                          
                                          
                                          <CardBody style={{ padding: "0 1rem" }}>

                                                {(displayNoTime) ?
                                                    <CardTitle tag="h4" style={{color:'red'}}>ไม่มีช่วงเวลาว่างในวันนี้</CardTitle>
                                                    :
                                                    <CardTitle tag="h4">{(AppointDate != null && AppointDate != "") ? "เลือกเวลานัดหมาย" :"เลือกวันที่นัดหมาย"}</CardTitle> 
                                                }
 
                                          </CardBody>
                                          {buttonContent}


                                      </Card>
                                  </Col>
                              </Row>
                              <Row>
                                  <Col className="text-center ml-auto mr-auto" xs="12">
                                      <div className="send-button">
                                          <Button                        
                                              block
                                              className="btn-round"
                                              color="secondary"
                                              size="lg"
                                              style={{ fontSize: '1.2em' }}
                                              onClick={e => handleLevel(1)}
                                          >
                                              <i className="fas fa-arrow-circle-left"></i> ย้อนกลับ
                                          </Button>

                                          <Button
                            
                                              block
                                              className="btn-round"
                                              color="warning"
                                              size="lg"
                                              style={{ fontSize: '1.2em' }}
                                              onClick={e => handleLevel(3)}
                                          >
                                              ถัดไป <i className="fas fa-arrow-circle-right"></i>
                                          </Button>
                                      </div>
                                  </Col>
                              </Row>

                      </Collapse>
                      <Collapse isOpen={(level==3)}>
                          <Row>
                          <Col className="ml-auto mr-auto" lg="6" md="8">
                              <div className="textarea-container" style={{ padding: 0 }}>
                                  <Label for="Description">บอกเล่าอาการเบื้องต้น
                                  <Input
                                      id="Description"
                                      cols="80"
                                      name="Description"
                                          placeholder="บอกเล่าอาการเบื้องต้น"
                                      rows="4"
                                      type="textarea"
                                      style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                      onChange={e => setDescription(e.target.value)}
                                      ></Input>
                                  </Label>
                              </div>

                                      {
                                          (files.length >= 1) ?
                                              <div className="clear-button">
                                                  <Button
                                                      block
                                                      //className="btn-round"
                                                      color="danger"
                                                      href="#pablo"
                                                      size="lg"
                                                      style={{ fontSize: '1.2em' }}
                                                      onClick={handleClear}
                                                  >
                                                      ล้างรูปใหม่
                                              </Button>
                                              </div> :
                                              ""
                                      }
                              <section className="container text-center" style={{cursor: 'pointer', border: '1px dashed', padding: '20px 0px'}}>
                                  <div {...getRootProps({ className: 'dropzone' })}>
                                      <input name="fileUpload" {...getInputProps()} /*onChange={handleChange}*/ />
                                      <p> <i className="now-ui-icons design_image"></i> แนบไฟล์รูปภาพรอยโรค </p>
                                      <p> หรือใบส่งตัวถ้ามี</p>
                                      <p>(Android เลือกทีละรูป)</p>
                                  </div>
                                  <aside style={thumbsContainer}>
                                      {thumbs}
                                  </aside>
                              </section>





                          <div className="send-button">
                                  <Button
                                          block
                                          className="btn-round"
                                          color="secondary"
                                          size="lg"
                                          style={{ fontSize: '1.2em' }}
                                          onClick={e => handleLevel(2)}
                                      >
                                          <i className="fas fa-arrow-circle-left"></i> ย้อนกลับ
                                  </Button>
                        
                                  <Button
                                      block
                                      className="btn-round"
                                      color="info"
                                      //href="#pablo"
                                      size="lg"
                                      style={{ fontSize: '1.2em' }}
                                      onClick={handleSubmit}
                                  >
                                         บันทึก <i className="fas fa-save"></i> 
                                  </Button>

                          </div>

                           {/* Note */}

                                      <Modal
                                          className="modal-dialog modal-dialog-centered"
                                          toggle={() => setModalNote(false)}
                                          isOpen={modalNote}>

                                          <div className="modal-header" style={{color:'white', background:'#b92a34', paddingBottom:'10px'}}>
                                              <h5 className="modal-title" id="exampleModalLiveLabel">
                                                  แจ้งเพื่อทราบ
                                              </h5>
                                              <button
                                                  aria-label="Close"
                                                  className="close"
                                                  type="button"
                                                  onClick={() => setModalNote(false)}
                                              >
                                                  <span aria-hidden={true}>×</span>
                                              </button>
                                          </div>
                                          <div className="modal-body">
                                              <p>เมนูนี้คือบริการนัดหมาย/จองคิว เพื่อมารับการรักษาที่โรงพยาบาลโรคผิวหนังเขตร้อนภาคใต้ จ.ตรัง</p>
                                              <p>หากต้องการปรึกษาและรับยาทางไปรษณีย์กรุณาเลือกเมนู "พบแพทย์ทางไกล"</p>
                                          </div>
                                          <div className="modal-footer">
                                              <Button
                                                  color="primary"
                                                  type="button"
                                                  onClick={() => setModalNote(false)}
                                              >
                                                  ตกลง
          </Button>
                                          </div>
                                      </Modal>

                                  {/* Confirm */}
                                  <Modal
                                      modalClassName="modal-mini modal-info"
                                      toggle={() => setModal2(false)}
                                      isOpen={modal2}
                                  >
                                      <div className="modal-header justify-content-center">
                                          <div className="modal-profile">
                                              <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                                          </div>
                                      </div>
                                      <ModalBody>

                                          <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? "ยืนยันการนัดหมาย" : "กำลังบันทึกข้อมูล"}</p>
                                                  <p> วันที่ {THDate} </p>
                                                  <p> เวลา {AppointTime.substring(0,5)} น. </p>
                                      </ModalBody>
                                      <div className="modal-footer">
                                          <Button
                                              className="btn-neutral"
                                              color="link"
                                              type="button"
                                              onClick={() => setModal2(false)}
                                          >
                                              ยกเลิก
                                      </Button>

                                          <Button
                                              className="btn-neutral"
                                              color="link"
                                              type="button"
                                              onClick={handleConfirm}
                                              disabled={icon == "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                          //onClick={() => setModal2(false)}
                                          >
                                              ยืนยัน
                                      </Button>



                                      </div>
                                  </Modal>


                                  {/* Error */}
                                  <Modal
                                      modalClassName="modal-mini modal-danger"
                                      toggle={() => setModalError(false)}
                                      isOpen={modalError}
                                  >
                                      <div className="modal-header justify-content-center">
                                          <div className="modal-profile">
                                              <i className="fa fa-times" style={{ color: 'red', fontSize: '2em' }}></i>
                                          </div>
                                      </div>
                                      <ModalBody>
                                          <p>ไม่สามารถบันทึกข้อมูลได้</p>
                                          <p> {errMsg} </p>
                                      </ModalBody>
                                      <div className="modal-footer justify-content-center">
                                          <Button
                                              className="btn-neutral"
                                              color="neutral"
                                              type="button"
                                              onClick={() => setModalError(false)}
                                          >
                                              ตกลง
                                      </Button>
                                      </div>
                                  </Modal>
                          </Col>
                          </Row>
                      </Collapse>
                    </form>
                  </Container>
        </div>
        <DefaultFooter />
      </div>
    </>
  );
}

export default BookingPage;
